var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5417 5.87516L11.5429 6.87391L12.6621 8.00016H6.875V9.41683H12.6621L11.5429 10.536L12.5417 11.5418L15.375 8.7085L12.5417 5.87516ZM4.04167 3.75016H9V2.3335H4.04167C3.2625 2.3335 2.625 2.971 2.625 3.75016V13.6668C2.625 14.446 3.2625 15.0835 4.04167 15.0835H9V13.6668H4.04167V3.75016Z",
    fill: "#4A3877"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.6d8d57783ab42ed7fb4a125acdbf89bf.svg";
export { ForwardRef as ReactComponent };